<div class="modal-header">
  <h4 class="modal-title">Send Invite</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeInviteForm()">
    <i class="fa fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">

  <form [formGroup]="inviteExternalBeneForm" #inviteBene = "ngForm" (ngSubmit)="inviteExternalBeneFormSub()">
    <div class="modal-body">
      <div class="container">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label class="required">Select Company</label>
            <p-dropdown class="w-100" [options]="listCompany" formControlName="company" optionLabel="companyName" optionValue="id" placeholder="Select Company"></p-dropdown>
            <span class="invalid-message"
            *ngIf="(inviteExternalBeneForm.get('company').touched || isSubmitted) && inviteExternalBeneForm.get('company').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="firstname" class="required">First Name</label>
            <input type="text" class="im-input" [ngClass]="{'im-input-error':(inviteExternalBeneForm.get('firstname').touched || isSubmitted) && inviteExternalBeneForm.get('firstname').errors?.required}" formControlName="firstname" placeholder="Enter" (change)="generateUniqueUsername(popover)">
            <span class="invalid-message"
              *ngIf="(inviteExternalBeneForm.get('firstname').touched || isSubmitted) && inviteExternalBeneForm.get('firstname').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="form-group col-md-4">
            <label for="firstname" class="required">Last Name</label>
            <input type="text" class="im-input" [ngClass]="{'im-input-error':(inviteExternalBeneForm.get('lastname').touched || isSubmitted) && inviteExternalBeneForm.get('lastname').errors?.required}" formControlName="lastname" placeholder="Enter" (change)="generateUniqueUsername(popover)">
            <span class="invalid-message"
            *ngIf="(inviteExternalBeneForm.get('lastname').touched || isSubmitted) && inviteExternalBeneForm.get('lastname').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          </div>
          <div class="form-group col-md-4">
            <label for="firstname">Middle Name</label>
            <input type="text" class="im-input" formControlName="middlename" placeholder="Enter">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="userId" class="required">User Id</label>
            <input type="text"
            class="im-input" minLength="5" maxlength="12" pattern="^([a-zA-Z0-9._-]{5,12})$"
            [ngClass]="{'im-input-error':(inviteExternalBeneForm.get('userId').touched || isSubmitted) && inviteExternalBeneForm.get('userId').errors?.required}" formControlName="userId" (focus)="autoGeneratedId=false;popover.close();" (keyup)="onChangeUserId()" ngbPopover="Recommended"
            [autoClose]="false"
            triggers="manual"
            #popover="ngbPopover"
            placement="top-right"
            popoverClass="username-recommended-popover">
            <span class="invalid-message"
            *ngIf="(inviteExternalBeneForm.get('userId').touched || isSubmitted) && inviteExternalBeneForm.get('userId').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <app-userId-validation 
          *ngIf="inviteExternalBeneForm.controls['userId'].dirty"
          [userId] = "inviteExternalBeneForm.value.userId"
          (isValid)= "setUserIdValidity($event)"  [isSystemGenerated]="autoGeneratedId">
         </app-userId-validation>
          </div>
          <div class="form-group col-md-4">
            <label for="communicationEmailId" class="required">Communication Email ID</label>
            <input type="text" class="im-input" [ngClass]="{'im-input-error':(inviteExternalBeneForm.get('communicationEmailId').touched || isSubmitted) && inviteExternalBeneForm.get('communicationEmailId').errors?.required}" formControlName="communicationEmailId" placeholder="Enter" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$">
            <span class="invalid-message"
              *ngIf="(inviteExternalBeneForm.get('communicationEmailId').touched || isSubmitted) && inviteExternalBeneForm.get('communicationEmailId').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="invalid-message"
            *ngIf="(inviteExternalBeneForm.get('communicationEmailId').touched || isSubmitted) && inviteExternalBeneForm.get('communicationEmailId').errors?.pattern">
            {{ getGlobalErrorMessages("INVALID_EMAIL") }}
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="im-btn im-btn-primary im-btn-md" [disabled]="inviteExternalBeneForm.invalid">
        Send Invite
      </button>
    </div>
  </form>
  </div>